import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VkoApproverWorkbenchRegulatoryDocumentFragment = { __typename?: 'RegulatoryDocument', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', name: string, id: string }, modifiedBy: { __typename?: 'User', name: string, id: string }, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null, workflow: { __typename?: 'Workflow', message?: string | null, status: Types.WorkflowStatus, clearingVKO: Array<{ __typename?: 'User', name: string, id: string }>, reapprovingVKO: { __typename?: 'User', name: string, id: string } } };

export type GetVkoApproverWorkbenchRegulatoryDocumentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetVkoApproverWorkbenchRegulatoryDocumentsQuery = { __typename?: 'Query', vkoApproverWorkbenchRegulatoryDocuments: { __typename?: 'VkoApproverWorkbenchResult', myScopeDocCount: number, todoItems?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', name: string, id: string }, modifiedBy: { __typename?: 'User', name: string, id: string }, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null, workflow: { __typename?: 'Workflow', message?: string | null, status: Types.WorkflowStatus, clearingVKO: Array<{ __typename?: 'User', name: string, id: string }>, reapprovingVKO: { __typename?: 'User', name: string, id: string } } }> | null, inputItems?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', name: string, id: string }, modifiedBy: { __typename?: 'User', name: string, id: string }, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null, workflow: { __typename?: 'Workflow', message?: string | null, status: Types.WorkflowStatus, clearingVKO: Array<{ __typename?: 'User', name: string, id: string }>, reapprovingVKO: { __typename?: 'User', name: string, id: string } } }> | null } };

export const VkoApproverWorkbenchRegulatoryDocumentFragmentDoc = gql`
    fragment VkoApproverWorkbenchRegulatoryDocument on RegulatoryDocument {
  id
  name
  createdAt
  modifiedAt
  createdBy {
    name
    id
  }
  modifiedBy {
    name
    id
  }
  regulation {
    id
    name
    regulationNumber
  }
  workflow {
    message
    status
    clearingVKO {
      name
      id
    }
    reapprovingVKO {
      name
      id
    }
  }
}
    `;
export const GetVkoApproverWorkbenchRegulatoryDocumentsDocument = gql`
    query GetVkoApproverWorkbenchRegulatoryDocuments {
  vkoApproverWorkbenchRegulatoryDocuments {
    todoItems {
      ...VkoApproverWorkbenchRegulatoryDocument
    }
    inputItems {
      ...VkoApproverWorkbenchRegulatoryDocument
    }
    myScopeDocCount
  }
}
    ${VkoApproverWorkbenchRegulatoryDocumentFragmentDoc}`;

/**
 * __useGetVkoApproverWorkbenchRegulatoryDocumentsQuery__
 *
 * To run a query within a React component, call `useGetVkoApproverWorkbenchRegulatoryDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVkoApproverWorkbenchRegulatoryDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVkoApproverWorkbenchRegulatoryDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVkoApproverWorkbenchRegulatoryDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetVkoApproverWorkbenchRegulatoryDocumentsQuery, GetVkoApproverWorkbenchRegulatoryDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVkoApproverWorkbenchRegulatoryDocumentsQuery, GetVkoApproverWorkbenchRegulatoryDocumentsQueryVariables>(GetVkoApproverWorkbenchRegulatoryDocumentsDocument, options);
      }
export function useGetVkoApproverWorkbenchRegulatoryDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVkoApproverWorkbenchRegulatoryDocumentsQuery, GetVkoApproverWorkbenchRegulatoryDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVkoApproverWorkbenchRegulatoryDocumentsQuery, GetVkoApproverWorkbenchRegulatoryDocumentsQueryVariables>(GetVkoApproverWorkbenchRegulatoryDocumentsDocument, options);
        }
export type GetVkoApproverWorkbenchRegulatoryDocumentsQueryHookResult = ReturnType<typeof useGetVkoApproverWorkbenchRegulatoryDocumentsQuery>;
export type GetVkoApproverWorkbenchRegulatoryDocumentsLazyQueryHookResult = ReturnType<typeof useGetVkoApproverWorkbenchRegulatoryDocumentsLazyQuery>;
export type GetVkoApproverWorkbenchRegulatoryDocumentsQueryResult = Apollo.QueryResult<GetVkoApproverWorkbenchRegulatoryDocumentsQuery, GetVkoApproverWorkbenchRegulatoryDocumentsQueryVariables>;